import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";

import {am4Settings} from "@/mixins/am4charts/am4Settings";

export const am4LegendMixin = {
    methods: {
        am4CreateLegend(chart) {
            if (this._am4ChartInvalid(chart)) {
                return
            }

            chart.legend = new am4charts.Legend()
            return chart.legend
        },
        am4SetupLegend(chart) {
            if (this._am4ChartInvalid(chart)  || _.isNil(chart.legend)) {
                return
            }

            chart.legend.useDefaultMarker = true
            chart.legend.position = "bottom"
        },

        // Ensure that the chart exists
        _am4ChartInvalid(chart) {
            return _.isNil(chart)
        },

        // Dispose a part of value from the am4 framework.
        _dispose(element) {
            if (!_.isNil(element)) {
                element.dispose()
                return null
            }
            return element
        },
    },
}